import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ConfigService } from '../../services';
import { Breadcrumbs } from './models/breadcrumbs';
import { BreadcrumbsService } from './services/breadcrumbs.service';

@Component({
    standalone: true,
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    imports: [CommonModule, RouterModule, MatIconModule],
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public breadcrumbs: Breadcrumbs[];
    public state: boolean = false;
    public showBreadcrumb: boolean;

    constructor(
        private breadcrumbsService: BreadcrumbsService,
        private configService: ConfigService
    ) {
        this.unsubscribe$ = new Subject<void>();
        this.breadcrumbs = [];
    }

    ngOnInit(): void {
        this.getConfiguration();
        this.breadcrumbsService
            .getMessage()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((breadcrumbs) => {
                this.breadcrumbs = breadcrumbs;
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getConfiguration(): void {
        this.showBreadcrumb = this.configService.showBreadcrumbs();
    }
}
